import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SummaryApi from "../common";
import { CATEGORY_DISPLAY_LIMIT, ROUTES } from "../constants";
import { request } from "../helpers/request";

const CategoryList = () => {
  const [categoryProduct, setCategoryProduct] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCategoryProduct = async () => {
    setLoading(true);
    try {
      const response = await request(SummaryApi.categoryProduct);
      const dataResponse = await response.json();
      if (dataResponse.success) {
        setCategoryProduct(dataResponse.data.slice(0, CATEGORY_DISPLAY_LIMIT));
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoryProduct();
  }, []);

  const tileCount = loading ? CATEGORY_DISPLAY_LIMIT : categoryProduct.length;
  // Responsive: 2 cols mobile, up to 6 cols desktop
  const gridCols =
    tileCount <= 2 ? "grid-cols-2" :
    tileCount <= 3 ? "grid-cols-3" :
    tileCount <= 4 ? "grid-cols-2 md:grid-cols-4" :
                     "grid-cols-2 md:grid-cols-3 lg:grid-cols-6";

  return (
    <section
      className={`w-full h-auto md:h-[260px] bg-[#111111] overflow-hidden grid ${gridCols} gap-[2px]`}
      aria-label="Shop by category"
    >
      {loading
        ? Array.from({ length: CATEGORY_DISPLAY_LIMIT }, (_, i) => (
            <div key={i} className="relative h-[130px] md:h-full bg-ds-surface-container animate-pulse" />
          ))
        : categoryProduct.map((product) => (
            <Link
              key={product.category}
              to={`${ROUTES.PRODUCT_CATEGORY}?category=${encodeURIComponent(product.category)}`}
              className="relative group overflow-hidden h-[130px] md:h-full block"
              aria-label={`Browse ${product.category}`}
            >
              {/* Category image — sourced from API product image */}
              <img
                src={product?.productImage?.[0]}
                alt={product.category}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.05]"
                loading="lazy"
              />

              {/* Dark overlay, lightens to primary tint on hover */}
              <div className="absolute inset-0 bg-black/50 transition-colors duration-300 group-hover:bg-ds-primary/20" />

              {/* Category label — bottom left */}
              <div className="absolute bottom-4 left-4 z-10">
                <h3 className="font-barlow font-bold text-[20px] md:text-[24px] text-white leading-none uppercase">
                  {product.category}
                </h3>
              </div>

              {/* BROWSE CTA — fades in on hover, bottom right */}
              <div className="absolute bottom-4 right-4 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="font-inter text-[13px] text-white font-semibold">
                  BROWSE →
                </span>
              </div>
            </Link>
          ))}
    </section>
  );
};

export default CategoryList;
